// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__1PjkR","title":"card_title__23X6A","inActive":"card_inActive__30Hjj"};